import types from '../../mutation-types';
import KanbanTasksAPI from '../../../api/kanban/tasks';

export const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isUpdating: false,
    isMoving: false,
  },
};

export const getters = {
  getTasks: _state => _state.records,
  getTasksByStep: _state => stepId =>
    _state.records.filter(t => t.board_step_id === stepId),
  getUIFlags: _state => _state.uiFlags,
};

export const actions = {
  fetch: async ({ commit }, boardId) => {
    commit(types.SET_KANBAN_TASKS_UI_FLAG, { isFetching: true });
    try {
      const response = await KanbanTasksAPI.list(boardId);
      commit(types.SET_KANBAN_TASKS, response.data || []);
    } finally {
      commit(types.SET_KANBAN_TASKS_UI_FLAG, { isFetching: false });
    }
  },

  create: async ({ commit }, { boardId, task }) => {
    commit(types.SET_KANBAN_TASKS_UI_FLAG, { isCreating: true });
    try {
      const response = await KanbanTasksAPI.create(boardId, task);
      commit(types.ADD_KANBAN_TASK, response.data);
      return response.data;
    } finally {
      commit(types.SET_KANBAN_TASKS_UI_FLAG, { isCreating: false });
    }
  },

  update: async ({ commit }, { boardId, id, task }) => {
    commit(types.SET_KANBAN_TASKS_UI_FLAG, { isUpdating: true });
    try {
      const response = await KanbanTasksAPI.update(boardId, id, task);
      commit(types.UPDATE_KANBAN_TASK, response.data);
      return response.data;
    } finally {
      commit(types.SET_KANBAN_TASKS_UI_FLAG, { isUpdating: false });
    }
  },

  move: async ({ commit, state: s }, { boardId, taskId, boardStepId }) => {
    const previous = s.records.find(t => t.id === taskId);
    if (!previous || previous.board_step_id === boardStepId) return;

    const previousStepId = previous.board_step_id;
    commit(types.MOVE_KANBAN_TASK, { taskId, boardStepId });
    commit(types.SET_KANBAN_TASKS_UI_FLAG, { isMoving: true });
    try {
      const response = await KanbanTasksAPI.move(boardId, taskId, boardStepId);
      commit(types.UPDATE_KANBAN_TASK, response.data);
    } catch (error) {
      commit(types.MOVE_KANBAN_TASK, {
        taskId,
        boardStepId: previousStepId,
      });
      throw error;
    } finally {
      commit(types.SET_KANBAN_TASKS_UI_FLAG, { isMoving: false });
    }
  },

  delete: async ({ commit }, { boardId, id }) => {
    await KanbanTasksAPI.destroy(boardId, id);
    commit(types.DELETE_KANBAN_TASK, id);
  },
};

export const mutations = {
  [types.SET_KANBAN_TASKS_UI_FLAG](_state, data) {
    _state.uiFlags = { ..._state.uiFlags, ...data };
  },
  [types.SET_KANBAN_TASKS](_state, records) {
    _state.records = records;
  },
  [types.ADD_KANBAN_TASK](_state, task) {
    _state.records.push(task);
  },
  [types.UPDATE_KANBAN_TASK](_state, task) {
    const idx = _state.records.findIndex(t => t.id === task.id);
    if (idx !== -1) _state.records.splice(idx, 1, task);
  },
  [types.DELETE_KANBAN_TASK](_state, id) {
    _state.records = _state.records.filter(t => t.id !== id);
  },
  [types.MOVE_KANBAN_TASK](_state, { taskId, boardStepId }) {
    const idx = _state.records.findIndex(t => t.id === taskId);
    if (idx !== -1) {
      _state.records.splice(idx, 1, {
        ..._state.records[idx],
        board_step_id: boardStepId,
      });
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
